import { CheckBox } from '@design/components/checkbox/CheckBox';
import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import clsx from 'clsx';
import React from 'react';

import styles from './DropdownCheckGroup.module.scss';

export interface DropdownCheckEntry {
  key: string;
  label: string;
  categories: {
    key: string;
    label: string;
    checked: boolean;
  }[];
  toggleAll: (payload: { key: string; checked: boolean }) => void;
}

export type DropdownCheckGroupProps = {
  item: DropdownCheckEntry;
  onChange: ({
    key,
    categoryKey,
    checked,
  }: {
    key: string;
    categoryKey: string;
    checked: boolean;
  }) => void;
};

export const DropdownCheckGroup = ({
  item,
  onChange,
}: DropdownCheckGroupProps) => {
  if (item.categories.length === 0) {
    return null;
  }

  const isAllChecked = item.categories.every(c => c.checked);
  const isSomeChecked = isAllChecked || item.categories.some(c => c.checked);

  return (
    <div className={styles.dropdownWrapper}>
      <RadixDropdown.CheckboxItem
        className={clsx(
          styles.dropdownMenuCheckboxItem,
          styles.multiselect
        )}
        checked={isAllChecked}
        onSelect={event => event.preventDefault()}
        data-testid="dropdown-select-all"
      >
        <CheckBox
          className={styles.dropdownCheckbox}
          name="select-all"
          label={item.label}
          checked={isSomeChecked}
          partial={isSomeChecked && !isAllChecked}
          size="small"
          onChange={(_, e) =>
            item.toggleAll({ key: item.key, checked: e.target.checked })
          }
        />
      </RadixDropdown.CheckboxItem>
      {item.categories.map(category => (
        <RadixDropdown.Group
          className={styles.dropdownGroup}
          key={category.key}
        >
          <RadixDropdown.CheckboxItem
            className={styles.dropdownMenuCheckboxItem}
            onSelect={event => event.preventDefault()}
            data-testid={`dropdown-group-item-${category.label}`}
            checked={category.checked}
          >
            <CheckBox
              className={styles.dropdownCheckbox}
              name={category.key}
              label={category.label}
              checked={category.checked}
              size="small"
              onChange={(key, e) =>
                onChange({
                  key: item.key,
                  categoryKey: key,
                  checked: e.target.checked,
                })
              }
            />
          </RadixDropdown.CheckboxItem>
        </RadixDropdown.Group>
      ))}
    </div>
  );
};
